export const environment = {
    production: false,
    sapSystem: "ST1",
    backendBaseUrlKloeber: "https://ab-konfigurator.w3code.de/Backend",
    backendBaseUrlSedus: "https://ab-konfigurator.w3code.de/Backend"
};
